import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'
import RAF from '@/js/utils/raf'

import GEOM from '@/glxp/geom'
import ShaderManifest from './shaderManifest'

class Plane extends Rendable {
  constructor (scene, word, texture, shader) {
    super(scene)

    this.gl = scene.gl
    this.scene = scene
    this.word = word
    this.texture = texture
    this.node = new Node()
    this.customSettings = {
      shakeScale: 0.9
    }

    this.shader = new Shader(ShaderManifest[shader])

    this.hasNormal = false

    this.initBuffer({
      vertices: GEOM.vertices,
      uvs: GEOM.uvs,
      indices: GEOM.indices
    })

    this.initProgram(this.shader.vert, this.shader.frag)
    this.initVao()
    this.initMatrix()
    this.createUniforms()
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uRez', 'float2')
    this.createUniform('uOverlay')
    this.createUniform('uShakeScale')
  }

  applyState () {
    let gl = this.gl

    this.scene.applyDefaultState()

    if (this.scene.customBlending !== undefined) {
      this.scene.customBlending()
    }

    gl.disable(gl.CULL_FACE)
    gl.disable(gl.DEPTH_TEST)
    gl.depthMask(false)
  }

  render () {
    let gl = this.gl
    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    gl.activeTexture(gl.TEXTURE0)
    gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture(this.texture))
    this.bindUniform('uTexture', 0)
    this.bindUniform('uRez', [this.scene.width, this.scene.height - this.scene.marginBottom])

    this.bindUniform('uShakeScale', this.customSettings.shakeScale)
    this.bindMatrixUniforms(this.scene.camera)

    gl.drawElements(gl.TRIANGLES, GEOM.indices.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Plane
